<template>
  <component
      v-bind="$attrs"
      v-on="$listeners"
      :is="fieldComponent"
      :label="value.attributeName"
      :value="value.value"
  />
</template>

<script>
import VgViewField from '@/components/Commons/VgViewField';
import ProjectField from './ProjectField';
import ConstructionTypeField from './ConstructionTypeField';
import ImagesField from './ImagesField';
import ImageField from './ImageField';
import DateField from './DateField';

export default {
  name: 'DpApplicationViewField',
  components: {VgViewField},
  props: {
    value: null
  },
  computed: {
    fieldComponent() {
      switch (this.value.attributeType) {
        case 'PROJECT_ID':
          return ProjectField
        case 'CONSTRUCTION_TYPE':
          return ConstructionTypeField
        case 'TP_OVERTIME_APPROVAL_PHOTO':
        case 'PHOTOS':
          return ImagesField
        case 'PERSONAL_PHOTO':
        case 'ID_CARD_PHOTO_FRONT':
        case 'ID_CARD_PHOTO_BACK':
          return ImageField
        case 'CONSTRUCTION_START_TIME':
        case 'CONSTRUCTION_END_TIME':
          return DateField
        case 'CONSTRUCTION_LOCATION':
        case 'CONSTRUCTOR':
        case 'CONSTRUCTION_CONTENT':
        case 'PERSONAL_NAME':
        case 'PHONE_NUMBER':
        case 'TENANT_COMPANY':
        case 'BRAND':
        default:
          return VgViewField
      }
    }
  }
}
</script>

<style scoped>

</style>
